export const CUSTOMER_AUTH_HANDOFF_TYPE = 'gspress:customer-authenticated'

export function customerAuthChannelName(vendorToken) {
  return `gspress:customer-auth:${vendorToken}`
}

export function customerAuthStorageKey(vendorToken) {
  return `${customerAuthChannelName(vendorToken)}:event`
}

function handoffMessage(draftPublicId) {
  return {
    type: CUSTOMER_AUTH_HANDOFF_TYPE,
    draftPublicId,
    sentAt: Date.now(),
    nonce: Math.random().toString(36).slice(2),
  }
}

export function publishCustomerAuthHandoff(vendorToken, draftPublicId) {
  if (!vendorToken || !draftPublicId) return false

  const message = handoffMessage(draftPublicId)

  try {
    window.localStorage.setItem(customerAuthStorageKey(vendorToken), JSON.stringify(message))
  } catch {
    // BroadcastChannel may still be available when storage is blocked.
  }

  if (typeof window.BroadcastChannel === 'function') {
    try {
      const channel = new window.BroadcastChannel(customerAuthChannelName(vendorToken))
      channel.postMessage(message)
      channel.close()
    } catch {
      // Storage remains the fallback when browser channel access is blocked.
    }
  }

  return true
}

export function subscribeToCustomerAuthHandoff(vendorToken, draftPublicId, onHandoff) {
  if (!vendorToken || !draftPublicId || typeof onHandoff !== 'function') return () => {}

  const handleMessage = (message) => {
    if (
      message?.type === CUSTOMER_AUTH_HANDOFF_TYPE &&
      String(message.draftPublicId) === String(draftPublicId)
    ) {
      onHandoff(message)
    }
  }
  const handleStorage = (event) => {
    if (event.key !== customerAuthStorageKey(vendorToken) || !event.newValue) return

    try {
      handleMessage(JSON.parse(event.newValue))
    } catch {
      // Ignore malformed or unrelated browser storage values.
    }
  }

  window.addEventListener('storage', handleStorage)
  let channel = null
  if (typeof window.BroadcastChannel === 'function') {
    try {
      channel = new window.BroadcastChannel(customerAuthChannelName(vendorToken))
    } catch {
      // Storage and focus checks still provide the handoff fallback.
    }
  }
  if (channel) channel.addEventListener('message', event => handleMessage(event.data))

  return () => {
    window.removeEventListener('storage', handleStorage)
    channel?.close()
  }
}

export function initializeCustomerAuthHandoff() {
  const container = document.getElementById('customer-sign-in-handoff')
  if (!container) return false

  return publishCustomerAuthHandoff(
    container.dataset.vendorToken,
    container.dataset.draftPublicId
  )
}

initializeCustomerAuthHandoff()
